import Cookies from 'js-cookie';
import { useEffect, useRef } from 'react';

import { AUTH_COOKIE_NAME, USER_TOKEN_EXPIRATION_TIME, USER_TOKEN_REFRESH_BEFORE_EXPIRATION } from '@constants';
import { showErrorToast } from '@hooks/showErrorToast';
import { refreshToken } from './useRefreshToken';

export const useTokenManager = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isScheduledRef = useRef(false);

  const clearRefreshTimeout = () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
      isScheduledRef.current = false;
    }
  };

  const scheduleTokenRefresh = () => {
    if (isScheduledRef.current) {
      return;
    }

    clearRefreshTimeout();
    const refreshTime = USER_TOKEN_EXPIRATION_TIME - USER_TOKEN_REFRESH_BEFORE_EXPIRATION;

    timeoutRef.current = setTimeout(async () => {
      isScheduledRef.current = false;
      const token = Cookies.get(AUTH_COOKIE_NAME);

      if (token) {
        try {
          await refreshToken();
          scheduleTokenRefresh();
        } catch (error) {
          showErrorToast('Failed to refresh token');
        }
      }
    }, refreshTime);

    isScheduledRef.current = true;
  };

  useEffect(() => {
    const token = Cookies.get(AUTH_COOKIE_NAME);
    if (token && !isScheduledRef.current) {
      scheduleTokenRefresh();
    }

    return () => clearRefreshTimeout();
  }, []);

  return { scheduleTokenRefresh };
};
